import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 任务 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("确定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu_divider = _resolveComponent("a-menu-divider")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_DownOutlined = _resolveComponent("DownOutlined")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!

  return (_openBlock(), _createBlock(_component_a_dropdown, {
    trigger: ['click'],
    visible: _ctx.visible,
    "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.visible) = $event)),
    getPopupContainer: _ctx.getContainer
  }, {
    overlay: _withCtx(() => [
      _createVNode(_component_a_menu, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_menu_item, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSelect('task')))
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_a_menu_divider),
          _createVNode(_component_a_menu_item, {
            key: "2",
            class: "no-hover"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.diyValue,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.diyValue) = $event)),
                onClick: _cache[2] || (_cache[2] = _withModifiers((e) => e.target.focus(), ["stop"])),
                placeholder: "请输入",
                style: {"width":"150px"}
              }, null, 8, ["value"]),
              _createVNode(_component_a_space, { style: {"margin-top":"10px","display":"flex","justify-content":"flex-end"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    onClick: _ctx.cancel,
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: _ctx.ok,
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_input, {
        value: _ctx.selectValue,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectValue) = $event)),
        readonly: "",
        placeholder: "请选择"
      }, {
        suffix: _withCtx(() => [
          _createVNode(_component_DownOutlined, {
            style: {"color":"#c8c8c8"},
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.visible = true))
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _: 1
  }, 8, ["visible", "getPopupContainer"]))
}